// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import VueCookies from 'vue-cookies'
import store from './store'
import 'element-ui/lib/theme-chalk/index.css';
import {
  Button,
  Image as VanImage,
  Field, CellGroup, Form,
  Tabbar, TabbarItem,
  Grid,
  GridItem,
  NoticeBar,
  List, Tab,
  Tabs,
  Cell,
  NavBar,
  Uploader,
  Card,
  Tag,
  Picker,
  Popup,
  DatetimePicker,
  Icon,
  Col,
  Row,
  Cascader,
  PullRefresh,
  Calendar,
  Empty,
  ImagePreview,
  Checkbox,
  CheckboxGroup,
  Search,
  DropdownMenu,
  DropdownItem,
  Rate,
  CollapseItem,
  Collapse,
  RadioGroup,
  Radio,
  Switch,
  Divider
} from 'vant'

Vue.use(Divider)
Vue.use(Collapse)
Vue.use(Switch)
Vue.use(RadioGroup)
Vue.use(Radio)
Vue.use(CollapseItem)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Search)
Vue.use(CheckboxGroup)
Vue.use(Checkbox)
Vue.use(Button)
Vue.use(Field)
Vue.use(Form)
Vue.use(VanImage)
Vue.use(CellGroup)
Vue.use(Tabbar)
Vue.use(TabbarItem)
Vue.use(Grid)
Vue.use(GridItem)
Vue.use(NoticeBar)
Vue.use(List)
Vue.use(Tab)
Vue.use(Tabs)
Vue.use(Cell)
Vue.use(NavBar)
Vue.use(Uploader)
Vue.use(Card)
Vue.use(Tag)
Vue.use(Picker)
Vue.use(Popup)
Vue.use(DatetimePicker)
Vue.use(Icon)
Vue.use(Col)
Vue.use(Row)
Vue.use(Cascader)
Vue.use(PullRefresh)
Vue.use(Empty)
Vue.use(Calendar)
Vue.use(ImagePreview)
Vue.use(Rate)
Vue.use(ElementUI)
Vue.use(VueCookies)
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js